import Swiper, { Navigation, Pagination, EffectFade, EffectCoverflow, Lazy } from 'swiper8';


(function ($) {    
    new Swiper('.slider', {
        modules: [Navigation, Pagination, EffectFade, Lazy],
        direction: 'horizontal',
        loop: true,
        lazy: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.slider-pagination',
            bulletClass: 'slider-pagination__bullet',
            bulletActiveClass: 'slider-pagination__bullet--active',
            clickable: true,
        },
        navigation: {
            prevEl: '.slider__arrow--prev',
            nextEl: '.slider__arrow--next',
        },
    });

        
    if ($('.reviews-slider').length) {
        
        const reviewsSlider = new Swiper('#reviews-slider', {
            modules: [EffectCoverflow],
            loop: true,
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 1,
            autoplay: false,
            effect: 'coverflow',
            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows : true,
            },
            breakpoints: {
                992: {
                    slidesPerView: 3
                },
            }
        });
        
        $(document).on('click', '#reviews-slider .swiper-slide-prev', function() {
            reviewsSlider.slidePrev();
        });
        
        $(document).on('click', '#reviews-slider .swiper-slide-next', function() {
            reviewsSlider.slideNext();
        });
        
    }
    
})(window.jQuery);
